// @flow
import React, { PureComponent } from 'react';
import IconButton from 'material-ui/IconButton';
import Message from '@material-ui/icons/Comment';
import Badge from '../../notifications/components/Badge';
import loadNotifications from '../../notifications/state/loadNotifications';
import { getStore } from '../../../state/store';
import * as AppState from '../../../state/reducer/app/appState';
import Console from '../../../lib/debug';
import SegmentService, {
    EVENTS as SEGMENT_EVENTS
} from '../../../lib/segment/SegmentService';
import markMessagingNotificationsAsViewed from '../../notifications/state/markMessagingNotificationsAsViewed';
import { subscribe } from './messagingCountPoller';

class MessagingButton extends PureComponent {
    constructor(props: any) {
        super(props);
        this.unsubscribe = null;
        this.state = { badgeCount: 0 };
        this.onClick = this.onClick.bind(this);
    }

    componentDidMount() {
        this.unsubscribe = subscribe((badgeCount: number) =>
            this.setState({ badgeCount })
        );
    }

    componentWillUnmount() {
        if (this.unsubscribe) this.unsubscribe();
    }

    onClick() {
        SegmentService.track(SEGMENT_EVENTS.ClickCTA.key, {
            sources: 'Web app',
            ctaLocation: 'Main Nav',
            ctaText: 'Message Icon'
        });
        getStore().dispatch(loadNotifications());
        this.setState({ badgeCount: 0 }, () => {
            getStore().dispatch(markMessagingNotificationsAsViewed());
            AppState.navigate('/messaging');
        });
    }

    render() {
        Console.render('NotificationButton');
        return (
            <IconButton
                className="notification-link"
                aria-label="Notification Bell"
                onClick={this.onClick}
            >
                <Message className="messaging-icon" />
                {this.state.badgeCount > 0 ? (
                    <Badge count={this.state.badgeCount} />
                ) : null}
            </IconButton>
        );
    }
}

export default MessagingButton;
